export const keywordCatalog = [
  "list property on krent",
  "krent onboarding guide",
  "krent real estate platform",
  "shortlet vs hotel lagos",
  "areas to rent in abuja on a budget",
  "renting in lokogoma",
  "shortlet apartments victoria island",
  "shortlet apartments ikeja",
  "renting in ibeju-lekki",
  "lagos housing crisis",
  "lagos real estate trends",
  "affordable areas to rent in lagos",
  "fake real estate offices lagos",
  "detty december shortlet lagos",
  "valentine date ideas nigeria",
  "valentine date ideas abuja",
  "valentine staycation abuja",
  "lagos shortlet market",
  "fine dining restaurants maitama",
  "affordable date ideas abuja",
  "valentine spots abuja",
  "fine dining restaurants asokoro",
  "valentine staycation lagos",
  "valentine ideas under 100k lagos",
  "indoor valentine ideas",
  "affordable date ideas lagos",
  "krent app for property agents",
  "fine dining restaurants ikeja",
  "fine dining restaurants lekki",
  "valentine spots lagos",
  "shortlet booking mistakes",
  "property documentation red flags",
  "where young professionals rent in lagos",
  "first-time renter mistakes nigeria",
  "renting an apartment in nigeria",
  "nightlife spots abuja",
  "nightlife spots victoria island",
  "mreif mortgage scheme nigeria",
  "nigeria housing deficit",
  "trade fair complex demolition",
  "things to do in lagos",
  "nigeria housing crisis data",
  "fg housing programme",
  "where to list rental property in nigeria",
  "efcc real estate fraud",
  "renting in langbasa",
  "buying land in nigeria",
  "where to rent in abuja",
  "advertise shortlet apartments nigeria",
  "krent for landlords and tenants",
  "best areas in lagos for remote workers",
  "romantic things to do in lagos",
  "ijgb december",
  "lagos december events",
  "shortlet facts",
  "things to do in lagos in december",
  "book shortlet for december in lagos",
  "lekki conservation centre",
  "best secondary schools in nigeria",
  "renting an apartment in lagos",
  "house for sale in nigeria",
  "renting a house in lagos",
  "famous buildings in lagos",
  "how to choose a short let apartment",
  "christmas home decoration ideas",
  "cost of short lets in lagos",
  "best locations for short let in lagos",
  "no legal fees renting",
  "residential estates lagos island",
  "budget-friendly places to visit in lagos",
  "land tenure system nigeria",
  "house designs in nigeria",
  "agency fees nigeria",
  "sell property online nigeria",
  "become a real estate agent in nigeria",
  "gra meaning nigeria",
  "real estate companies in lagos",
  "land sizes in nigeria",
  "abuja districts and phases",
  "best places to live in lagos",
  "best places to live in abuja",
  "beaches in lekki",
  "lekki unauthorized buildings",
  "landmark group title dispute",
  "shared apartments lagos",
  "shipping container homes ghana",
  "studio apartments lagos",
  "lagos planning permit grace period",
  "fmbn fund",
  "kantagua market lagos",
  "rent short-let apartment lagos",
  "housing minister transparency",
  "affordable housing research nigeria",
  "edo land papers",
  "diaspora city project nigeria",
  "hdan real estate professionalism",
  "nigeria housing budget",
  "lekki demolitions",
  "cafes in lagos island",
  "housing fraud nigeria",
  "lagos building collapse",
  "real estate financing challenges nigeria",
  "kenya land selling firms license fee",
  "real estate gdp nigeria",
  "interest rate real estate nigeria",
  "lasbca developer authorization letter",
  "monthly rent policy lagos",
  "places to live in lagos mainland",
  "rivers state housing units construction materials prices nigeria",
  "housing minister",
  "surveyors abuja",
  "radisson hotels africa",
  "tax breaks housing nigeria",
  "unauthorized building use lagos",
  "nigeria real estate growth",
  "land restoration nigeria",
  "alimosho city plan",
  "town planning nigeria",
  "rising rents nigeria",
  "nigeria housing units government",
  "marina shoreline recovery",
  "niesv",
  "laspppa developers compliance",
  "homelessness nigeria",
  "nar partnership nigeria real estate",
  "nigeria real estate fdi",
  "insecurity real estate nigeria",
  "real estate trends nigeria",
  "real estate marketing nigeria",
  "mandilas fire",
  "africa real estate",
  "inflation real estate nigeria",
  "cement prices nigeria",
  "estate construction forest reserve oyo",
  "high rent protest nigeria",
  "real estate deals nigeria",
  "turnkey projects nigeria developers",
  "lasrera efcc real estate fraud",
  "real estate transactions krent",
  "krent nigeria real estate",
  "future of nigerian real estate",
  "shortlet apartments yaba",
  "co-working spaces in lagos",
  "restaurants in surulere",
  "krent instant booking",
  "shortlet apartments surulere",
  "cafes in surulere",
  "affordable shortlet surulere",
  "shortlet areas in abuja",
  "shortlet apartments garki abuja",
  "monthly shortlet abuja",
  "shortlet price abuja",
  "real estate in nigeria",
  "property for sale in nigeria",
  "property for rent in nigeria",
  "shortlet apartments in nigeria",
  "commercial property for sale in nigeria",
  "apartments for sale in nigeria",
  "houses for sale in nigeria",
  "houses for rent in nigeria",
  "apartments for rent in nigeria",
  "land for lease in nigeria",
  "shortlet apartments in lekki",
  "shortlet apartments in lagos",
  "properties in nigeria",
  "krent faq",
  "list your property on krent",
  "about krent",
  "contact krent",
  "krent privacy policy",
  "krent terms of use",
  "Affordable shortlet apartments in Lagos",
  "2 bedroom shortlet apartment in Lekki Phase 1",
  "3 bedroom shortlet apartment in Ikeja Lagos",
  "Shortlet apartments with swimming pool in Lekki",
  "Shortlet apartments in Ikeja GRA with WiFi",
  "Shortlet apartments for family vacations in Lagos",
  "Verified shortlet apartments in Lagos Nigeria",
  "Luxury shortlet apartments in Ikoyi Lagos",
  "Shortlet apartments in Victoria Island with pool",
  "Shortlet apartments for bridal shower in Lagos",
  "Party-friendly shortlet apartments in Ikeja",
  "Shortlet apartments near Lagos airport",
  "Shortlet apartments for December in Lagos",
  "Monthly shortlet apartments in Lagos Nigeria",
  "Fully furnished shortlet apartments in Abuja",
  "3 bedroom duplex shortlet with pool in VGC Lekki",
  "Shortlet apartments in Surulere for group stays",
  "Serviced apartments for business travellers in Lagos",
  "Shortlet apartments in Lagos with 24-hour power",
  "Shortlet apartments in Lagos for returning Nigerians",
  "Best shortlet apartments in Lagos",
  "Best shortlet booking websites in Nigeria",
  "Best shortlet booking app in Lagos",
  "Affordable shortlets in Lekki",
  "Best serviced apartments in Abuja",
  "Luxury shortlets in Victoria Island",
  "Shortlet vs hotel in Lagos",
  "Airbnb alternatives in Nigeria",
  "Best areas to book shortlets in Lagos",
  "Shortlet apartments with good reviews in Lagos",
  "Shortlet prices in Lekki vs Ikeja",
  "Verified shortlet platforms in Nigeria",
  "Book shortlet in Lagos",
  "Book shortlet in Abuja",
  "Shortlet apartment booking Lagos",
  "Shortlet in Lekki Phase 1",
  "Shortlet in Ikeja GRA",
  "2 bedroom shortlet in Ikoyi",
  "3 bedroom shortlet in Surulere",
  "Shortlet in Victoria Island Lagos",
  "Book serviced apartment in Lagos",
  "Shortlet with pool in Lekki",
  "Instant booking shortlet Lagos",
  "Shortlet in Lagos for weekend",
  "Apartment for rent in Lekki",
  "2 bedroom flat for rent in Ikeja",
  "Houses for sale in Lagos",
  "Airbnb Lagos",
  "Airbnb Lekki",
  "Vacation rentals Lagos",
  "Holiday apartments Lagos",
  "Serviced apartments Lagos",
  "Apartments in Lagos",
  "Accommodation in Ikeja",
  "Houses for rent in Lagos",
  "Flats for rent in Lekki",
  "Property for sale in Abuja",
  "Apartments for rent Lagos",
  "Houses for sale Lekki",
  "Real estate Nigeria",
  "Verified shortlets Lagos",
  "Shortlet booking app Nigeria",
  "Shortlet in Lekki",
  "Airbnb alternatives in Lagos",
  "Best alternatives to Airbnb in Nigeria",
  "Verified shortlet booking websites Nigeria",
  "Shortlet booking without inspection fee",
  "Instant shortlet booking in Lagos",
  "Book shortlet apartment online in Nigeria",
  "Shortlet apartments with virtual tours Lagos",
  "Shortlet platforms for property owners Nigeria",
  "Where to list shortlet apartments in Lagos",
  "Best property listing websites in Nigeria",
  "Shortlet booking sites with secure payment",
  "Affordable Airbnb alternatives in Lekki",
  "How much is a shortlet in Lagos",
  "Monthly shortlet apartments Lagos",
  "Party shortlet apartments Lagos",
  "Cheap shortlet apartments Lagos Mainland",
  "Best shortlet apartments Abuja",
  "Shortlet prices Abuja",
  "Shortlets in Wuse Abuja",
  "Shortlet booking apps Nigeria",
  "How to advertise shortlet apartments Nigeria",
  "Best areas to rent in Abuja",
  "Shortlet vs hotel Lagos",
  "What is a shortlet apartment in Nigeria",
  "How do shortlet apartments work",
  "How much does a shortlet cost in Lagos",
  "How to book a shortlet in Nigeria",
  "How to avoid fake shortlet apartments in Lagos",
  "Best places to stay in Lagos for vacation",
  "What to check before booking a shortlet",
  "Best areas for shortlets in Abuja",
  "Daily vs monthly shortlet apartments",
  "How to rent an apartment in Lagos",
  "How much is house rent in Lagos",
  "Cheapest areas to rent in Abuja",
  "Best places to live in Lekki",
  "Cost of renting a flat in Ikeja",
  "How to avoid rental scams in Nigeria",
  "Documents needed to rent a house in Nigeria",
  "How to buy property in Lagos",
  "How to verify property ownership in Nigeria",
  "What to know before renting in Abuja",
  "How to start a shortlet business in Nigeria",
  "How profitable is shortlet business in Lagos",
  "How to advertise shortlet apartments",
  "Where to list shortlet apartments in Nigeria",
  "How to get more shortlet bookings",
  "How to price shortlet apartments in Lagos",
  "How to manage shortlet apartments",
  "How to become a shortlet host in Nigeria",
  "Krent",
  "Krent Nigeria",
  "Krent real estate",
  "Krent shortlet",
  "Krent shortlet Lagos",
  "Krent shortlet Abuja",
  "Krent property listings",
  "Krent apartments",
  "Krent rentals",
  "Krent app",
  "Krent booking",
  "Krent instant booking",
  "Krent verified properties",
  "Krent reviews",
  "Krent customer service",
  "Krent property agents",
  "Krent host registration",
  "Krent vs Airbnb",
  "Shortlet in Lagos",
  "Shortlet in Abuja",
  "Affordable shortlets Lagos",
  "Luxury shortlets Lekki",
  "Flats for rent Abuja",
  "2 bedroom flat Lekki",
  "Houses for rent Ikeja",
  "Houses for sale Lagos",
  "Property for sale Abuja",
  "Land for sale Lekki",
  "Real estate listings Nigeria",
  "Shortlet booking Nigeria",
  "Verified shortlet apartments",
  "Shortlet booking websites",
  "Shortlet apartments in Lagos",
  "Shortlet apartments in Abuja",
  "Shortlet in Ikeja",
  "Shortlet in Victoria Island",
  "Shortlet in Ikoyi",
  "3 bedroom shortlet in Ikeja",
  "2 bedroom shortlet in Lekki",
  "Shortlet with pool in Lagos",
  "Party shortlet apartments in Lagos",
  "Verified shortlet apartments in Lagos",
  "Shortlet booking websites in Nigeria",
  "Monthly shortlet apartments in Lagos",
  "Shortlet in Surulere",
  "Shortlet in Wuse Abuja",
  "Shortlet in Jabi Abuja",
  "Apartments for rent in Lagos",
  "Houses for rent in Abuja",
  "List my shortlet in Nigeria",
  "Krent shortlet booking",
] as const;

export const allSuppliedKeywordText = keywordCatalog.join(", ");
